import { createContext, useContext, type ReactElement, type ReactNode } from 'react';
import type { MyBlogDto } from '@gr/core/accounts/workspaces/dto';
import { roleHasPermission, type BlogPermission } from '@gr/core/accounts/workspaces/permissions';

// Текущий блог и права роли в нём (WS-UC-6) для страниц внутри /b/:blogId.
export interface BlogContextValue {
  blog: MyBlogDto;
  can(permission: BlogPermission): boolean;
  reloadBlog(): Promise<void>;
}

const Context = createContext<BlogContextValue | null>(null);

export function BlogProvider({ blog, reloadBlog, children }: { blog: MyBlogDto; reloadBlog(): Promise<void>; children: ReactNode }): ReactElement {
  const value: BlogContextValue = { blog, can: (permission) => roleHasPermission(blog.role, permission), reloadBlog };
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useBlog(): BlogContextValue {
  const value = useContext(Context);
  if (!value) throw new Error('Страница блога вне BlogProvider');
  return value;
}
